import React, { useCallback } from 'react'
import { Select } from 'antd'
import { isUndefined, noop } from 'lodash'
import PropTypes from 'prop-types'

import { SIZES } from '../../constants'
import { antFormItemNamePropType } from '../../prop-types'

const ListItemSelect = ({
  name,
  options,
  onChange,
  shouldModify,
  value,
  onClear,
  ...rest
}) => {
  const handleOnChange = useCallback(
    value => {
      if (isUndefined(value)) {
        onClear(name)
        return
      }

      if (shouldModify(value)) {
        onChange(value)
      }
    },
    [name, onChange, onClear, shouldModify],
  )

  return (
    <Select
      onChange={handleOnChange}
      value={value}
      dropdownMatchSelectWidth={SIZES.DROPDOWN_MIN_WIDTH}
      options={options}
      {...rest}
    />
  )
}

ListItemSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  shouldModify: PropTypes.func.isRequired,
  name: antFormItemNamePropType.isRequired,
  options: PropTypes.array.isRequired,
  onClear: PropTypes.func.isRequired,
}

ListItemSelect.defaultProps = {
  value: undefined,
  onChange: noop,
}

export default ListItemSelect
